import ToolbarTitle from "design/components/texts/ToolbarTitle";
import Tabs from "design/components/toolbar/Tabs";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import Center from "design/layouts/Center";
import SplitView from "design/layouts/SplitView";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useLink";
import { getFileApiURL } from "qpr-base/utils/url-utils";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import { t } from "i18next";

const useIconStyles = makeThemedStyles("ReportsToolbarIcon", (theme) => ({
  root: {
    marginLeft: 0,
    marginRight: "15px",
    marginTop: "5px",
    width: "50px",
    height: "50px",
    backgroundImage: `url(${getFileApiURL(`/icons/navitems/reporting.svg`)})`,
  },
}));

const ReportsToolbar = (props: { selected?: string }) => {
  const ctx = useAppContext();
  const link = useLink();
  const iconstyles = useIconStyles();
  return (
    <ToolbarContainer>
      <SplitView partCnt={3}>
		  <ToolbarTitle>
			  <span className={iconstyles.root}></span>
			  {ctx.page === "reporttemplates"
				  ? t("reports.Report Templates")
				  : ctx.page === "reportworkflow"
					  ? t("reports.Report Workflow")
					  : t("reports.Configurable Reports")}
		  </ToolbarTitle>
        <Center>
          <Tabs
            onChange={(value) => {
              link({
                page: value,
              });
            }}
            selected={props.selected || ctx.page || ""}
            options={[
              {
                viewName: "reporttemplates",
                title: t("reports.Report Templates"),
              },
              {
                viewName: "configurablereports",
                title: t("reports.Configurable Reports"),
              },
			{
				viewName: "reportworkflow",
				title: t("reports.Report Workflow"),
			},
            ]}
          />
        </Center>
      </SplitView>
    </ToolbarContainer>
  );
};

export default ReportsToolbar;
